import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Icon } from '@shared/ui';

import cls from './ImportModal.module.css';
import { useAppSelector } from '../../../../store';
import { useGetBankPaymentParsersQuery } from '../../lib/hooks/useGetBankPaymentParsersQuery';

const ACCEPTED_FORMATS = ['.xls', '.xlsx'];

export const useImportModal = () => {
    const { t } = useTranslation();

    const [fileError, setFileError] = useState(null);
    const [importForm, setImportForm] = useState<{
        account: string;
        bank: string;
        file: File | null;
    }>({
        account: '',
        bank: '',
        file: null,
    });

    const { data } = useGetBankPaymentParsersQuery();

    const { accountsSelectList } = useAppSelector((state) => state.paymentReducer);

    const banksList = data?.map((bank) => ({
        value: bank.code,
        label: bank.name,
        iconUrl: bank.logoSvg,
    }));

    let accountsList = accountsSelectList
        .filter((account) => !account.account.integration)
        .map((item: { value: string; title: string }) => ({
            value: item.value,
            label: item.title,
        }));

    const addAccountOption = {
        value: 'addAccountOption',
        label: 'Создать счет',
        callback: () => {
            window.location.href = routable.getRoute('viewCompanyAccounts');
        },
        classes: cls.createAccount,
        icon: <Icon iconName="plus" color="#1094F7" />,
    };

    if (!accountsList.length) {
        accountsList = [addAccountOption, ...accountsList];
    }

    const handleFile = (fileList: FileList | null) => {
        if (!fileList || fileList.length === 0) return;
        const file = fileList[0];
        const ext = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
        if (!ACCEPTED_FORMATS.includes(ext)) {
            setFileError(t('ImportModal.handleFile.formatError'));
            return;
        }

        if (fileList.length > 1) {
            setFileError(t('ImportModal.handleFile.countError'));
            return;
        }

        setFileError(null);
        setImportForm((prev) => ({
            ...prev,
            file,
        }));
    };

    const onAccountSelect = (value: string) => {
        setImportForm((prev) => ({
            ...prev,
            account: value,
        }));
    };

    const onBankSelect = (value: string) => {
        setImportForm((prev) => ({
            ...prev,
            bank: value,
        }));
    };

    const noAppropriateAccounts = accountsList.length === 1;

    return {
        importForm,
        accountsList,
        onAccountSelect,
        banksList,
        onBankSelect,
        handleFile,
        fileError,
        t,
        addAccountOption,
        noAppropriateAccounts,
    };
};
